import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/Deposit.svg';
import _imports_1 from '@/assets/icon/Withdraw.svg';
import _imports_2 from '@/assets/icon/Transfer.svg';
import _imports_3 from '@/assets/icon/balance-Exchange.png';
import _imports_4 from '@/assets/icon/balance-Exchange-B.png';
import _imports_5 from '@/assets/icon/balance-Futures.png';
import _imports_6 from '@/assets/icon/balance-Futures-B.png';
import _imports_7 from '@/assets/icon/balance-IEO.png';
import _imports_8 from '@/assets/icon/balance-IEO-B.png';
import _imports_9 from '../../assets/icon/lock-account.png';
import _imports_10 from '../../assets/icon/service-account.png';

const _withScopeId = n => (_pushScopeId("data-v-bcbdf170"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "balance-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "padding": "10px 0",
    "font-size": "18px",
    "font-weight": "700",
    "background-color": "var(--bg-color)",
    "color": "var(--text-color)"
  }
};
const _hoisted_3 = {
  class: "balance-item"
};
const _hoisted_4 = {
  class: "btn-area"
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "width": "100%",
    "padding": "15px 0",
    "color": "black"
  }
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "25px"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "20px"
  }
})], -1));

const _hoisted_7 = {
  style: {
    "font-weight": "600"
  }
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "1px",
    "height": "30px",
    "background-color": "var(--gray-color)"
  }
}, null, -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "25px"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "20px"
  }
})], -1));

const _hoisted_10 = {
  style: {
    "font-weight": "600"
  }
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "1px",
    "height": "30px",
    "background-color": "var(--gray-color)"
  }
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "25px"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "width": "20px"
  }
})], -1));

const _hoisted_13 = {
  style: {
    "font-weight": "600"
  }
};
const _hoisted_14 = {
  style: {
    "position": "relative",
    "top": "0",
    "left": "0",
    "margin-bottom": "20px",
    "z-index": "3",
    "width": "100%"
  }
};
const _hoisted_15 = {
  class: "content"
};
const _hoisted_16 = {
  class: "item-name"
};
const _hoisted_17 = {
  key: 0,
  src: _imports_3,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
};
const _hoisted_18 = {
  key: 1,
  src: _imports_4,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
};
const _hoisted_19 = {
  class: "item-data"
};
const _hoisted_20 = {
  class: "num"
};
const _hoisted_21 = {
  class: "content",
  style: {
    "background-color": "var(--gray-color)"
  }
};
const _hoisted_22 = {
  class: "item-name"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
}, null, -1));

const _hoisted_24 = {
  class: "item-data"
};
const _hoisted_25 = {
  class: "num"
};
const _hoisted_26 = {
  class: "content",
  style: {
    "background-color": "var(--gray-color)"
  }
};
const _hoisted_27 = {
  class: "item-name"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
}, null, -1));

const _hoisted_29 = {
  class: "item-data"
};
const _hoisted_30 = {
  class: "num"
};
const _hoisted_31 = {
  style: {
    "position": "relative",
    "top": "0",
    "left": "0",
    "margin-bottom": "20px",
    "z-index": "3",
    "width": "100%"
  }
};
const _hoisted_32 = {
  class: "content"
};
const _hoisted_33 = {
  class: "item-name"
};
const _hoisted_34 = {
  key: 0,
  src: _imports_5,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
};
const _hoisted_35 = {
  key: 1,
  src: _imports_6,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
};
const _hoisted_36 = {
  class: "item-data"
};
const _hoisted_37 = {
  class: "num"
};
const _hoisted_38 = {
  class: "content",
  style: {
    "background-color": "var(--gray-color)"
  }
};
const _hoisted_39 = {
  class: "item-name"
};

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
}, null, -1));

const _hoisted_41 = {
  class: "item-data"
};
const _hoisted_42 = {
  class: "num"
};
const _hoisted_43 = {
  class: "content",
  style: {
    "background-color": "var(--gray-color)"
  }
};
const _hoisted_44 = {
  class: "item-name"
};

const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
}, null, -1));

const _hoisted_46 = {
  class: "item-data"
};
const _hoisted_47 = {
  class: "num"
};
const _hoisted_48 = {
  style: {
    "position": "relative",
    "top": "0",
    "left": "0",
    "margin-bottom": "20px",
    "z-index": "3",
    "width": "100%"
  }
};
const _hoisted_49 = {
  class: "content"
};
const _hoisted_50 = {
  class: "item-name"
};
const _hoisted_51 = {
  key: 0,
  src: _imports_7,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
};
const _hoisted_52 = {
  key: 1,
  src: _imports_8,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
};
const _hoisted_53 = {
  class: "item-data"
};
const _hoisted_54 = {
  class: "num"
};
const _hoisted_55 = {
  class: "content",
  style: {
    "background-color": "var(--gray-color)"
  }
};
const _hoisted_56 = {
  class: "item-name"
};

const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
}, null, -1));

const _hoisted_58 = {
  class: "item-data"
};
const _hoisted_59 = {
  class: "num"
};
const _hoisted_60 = {
  class: "content",
  style: {
    "background-color": "var(--gray-color)"
  }
};
const _hoisted_61 = {
  class: "item-name"
};

const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
}, null, -1));

const _hoisted_63 = {
  class: "item-data"
};
const _hoisted_64 = {
  class: "num"
};
const _hoisted_65 = {
  key: 0,
  class: "balance-overview"
};
const _hoisted_66 = {
  class: "content"
};
const _hoisted_67 = {
  class: "item-name"
};

const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
}, null, -1));

const _hoisted_69 = {
  class: "item-data"
};
const _hoisted_70 = {
  class: "num"
};
const _hoisted_71 = {
  key: 1,
  class: "balance-overview"
};
const _hoisted_72 = {
  class: "content"
};
const _hoisted_73 = {
  class: "item-name"
};

const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  style: {
    "width": "20px",
    "margin-right": "8px"
  }
}, null, -1));

const _hoisted_75 = {
  class: "item-data"
};
const _hoisted_76 = {
  class: "num"
};
const _hoisted_77 = {
  class: "balance-item"
};
const _hoisted_78 = {
  class: "btn-area"
};
const _hoisted_79 = {
  class: "btn-area"
};
const _hoisted_80 = {
  class: "btn-area"
};
const _hoisted_81 = {
  class: "balance-item"
};
const _hoisted_82 = {
  class: "balance-item"
};
const _hoisted_83 = {
  class: "balance-item"
};
const _hoisted_84 = {
  class: "balance-item"
};
import { ref, onActivated, computed } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/store';
import WalletCard from '@/components/WalletCard.vue';
import BalanceCurrency from '@/components/BalanceCurrency.vue';
import { getUserAsset, assetStat } from '@/apis';
import BigNumber from 'bignumber.js';
import { useI18n } from "vue-i18n";
import { ArrowRightOutlined } from '@ant-design/icons-vue';
import AssetsEchart from '@/components/charts/AssetsEChart.vue';
export default {
  __name: 'BalancesTab',

  setup(__props) {
    const {
      t
    } = useI18n();
    const router = useRouter();
    const tabActive = ref(0);
    const currencyList = ref([]);
    const contractTotal = ref('0');
    const contractList = ref([]);
    const ieoList = ref([]);
    const lockTotal = ref('0');
    const lockList = ref([]);
    const serviceTotal = ref('0');
    const serviceList = ref([]);
    const refreshing = ref(false);
    const chartsData = ref([]);

    const getBtnStyle = width => {
      return {
        '--van-button-border-radius': '2px',
        width: width,
        '--van-button-default-height': '32px',
        fontSize: '13px'
      };
    };

    const currencyTotal = computed(() => {
      let all = 0;

      if (spotList.value.length > 0) {
        spotList.value.map(item => {
          let allUsd = '0';
          allUsd = (Number(item.active + item.frozen + item.futureFrozen) * Number(store.state.market[item.marketSymbol]?.last)).toFixed(8);

          if (item.marketSymbol == 'USDT') {
            allUsd = item.active.toFixed(5);
          }

          all = BigNumber(all).plus(allUsd);
        });
      }

      all = Number(all);
      return Number.isNaN(all) || !Number.isFinite(all) ? 0 : all.toFixed(5);
    });
    const spotList = ref([]);

    const assetInit = () => {
      getUserAsset({
        platform: 0
      }).then(res => {
        if (res.code === 200 && res.data) {
          spotList.value = res.data;
          let total = 0;
          currencyList.value = res.data.map(item => {
            const freeze = res.data.length != 0 ? Math.floor((item.frozen + item.futureFrozen) * 100000) / 100000 : '0';
            const active = res.data.length != 0 ? Math.floor(item.active * 100000) / 100000 : '0';
            let allUsd = '0';
            allUsd = item.active + item.frozen + item.futureFrozen;

            if (item.marketSymbol == 'USDT') {
              allUsd = Math.floor(item.active * 100000) / 100000;
            }

            return {
              id: item.marketId,
              icon: item.icon,
              name: item.marketName,
              symbol: item.marketSymbol,
              freeze: freeze,
              active: active,
              usd: Number(allUsd)
            };
          });
          currencyTotal.value = total.toFixed(5);
        }
      });
    };

    const tradeInit = () => {
      getUserAsset({
        platform: 1
      }).then(res => {
        if (res.code === 200 && res.data) {
          const findItem = res.data.find(item => item.marketName === 'USDT');

          if (findItem) {
            const frozen = findItem ? Math.floor((findItem.frozen + findItem.futureFrozen) * 100000) / 100000 : '0';
            const active = findItem ? Math.floor(findItem.active * 100000) / 100000 : '0';
            const allUsd = findItem ? Math.floor(findItem.active * 100000) / 100000 : '0';
            contractList.value = [{
              id: findItem.marketId,
              icon: findItem.icon,
              name: findItem.marketName,
              symbol: findItem.marketSymbol,
              freeze: frozen,
              active: active,
              usd: Number(allUsd)
            }];
            contractTotal.value = allUsd;
          }
        }
      });
    };

    const ieoInit = () => {
      getUserAsset({
        platform: 0
      }).then(res => {
        if (res.code === 200 && res.data) {
          const findItem = res.data.find(item => item.marketName === 'ERS');

          if (findItem) {
            const frozen = findItem ? Number(findItem.frozen + findItem.futureFrozen).toFixed(5) : '0';
            const active = findItem ? Number(findItem.active).toFixed(5) : '0';
            const allUsd = findItem ? Number(findItem.active + findItem.frozen + findItem.futureFrozen).toFixed(5) : '0';
            ieoList.value = [{
              id: findItem.marketId,
              icon: findItem.icon,
              name: findItem.marketName,
              symbol: findItem.marketSymbol,
              freeze: frozen,
              active: active,
              usd: Number(allUsd)
            }];
          }
        }
      });
    };

    const pledgeEnable = ref(false);
    const serviceEnable = ref(false);

    const init = async () => {
      assetInit();
      tradeInit();
      ieoInit();
    };

    const refresh = () => {
      refreshing.value = true;
      init().finally(() => {
        refreshing.value = false;
      });
    };

    const getAllTotal = () => {
      return BigNumber(currencyTotal.value).plus(contractTotal.value).plus(lockTotal.value).plus(serviceTotal.value).toFixed(5);
    };

    const goToHistory = (type, item) => {
      const {
        id,
        name,
        freeze,
        active,
        usd,
        symbol
      } = item;
      router.push({
        name: 'balanceHistory',
        query: {
          type: type,
          id: id,
          name: name,
          freeze: freeze,
          active: active,
          usd: usd,
          symbol: symbol
        }
      });
    };

    onActivated(() => {
      init();
      getChartsData();
    });

    const goToIeo = () => {};

    const ieoTotal = computed(() => {
      let all = 0;
      if (ieoList.value.length > 0) all = Number((Number(ieoList.value[0].active) + Number(ieoList.value[0].freeze)) * Number(store.state.market[ieoList.value[0].symbol]?.last)).toFixed(6);
      return Number.isNaN(Number(all)) || !Number.isFinite(Number(all)) ? 0 : Number(all).toFixed(5);
    });

    const getChartsData = async () => {
      const res = await assetStat({});

      if (res.code == 200 && res.data) {
        chartsData.value = res.data; // chartsData.value = [{amount:123,createTime:123},{amount:150,createTime:123},{amount:213,createTime:123},{amount: 250,createTime:123}]
      }
    };

    return (_ctx, _cache) => {
      const _component_van_tab = _resolveComponent("van-tab");

      const _component_van_button = _resolveComponent("van-button");

      const _component_van_tabs = _resolveComponent("van-tabs");

      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('all')), 1), _createVNode(_component_van_pull_refresh, {
        onRefresh: refresh,
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => refreshing.value = $event),
        "pulling-text": _unref(t)('pulling'),
        "loosing-text": _unref(t)('loosing'),
        "loading-text": _unref(t)('loading')
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabs, {
          active: tabActive.value,
          "onUpdate:active": _cache[21] || (_cache[21] = $event => tabActive.value = $event),
          class: "content-tab"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_tab, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(WalletCard, {
              total: getAllTotal(),
              "balance-show": false,
              style: {
                "position": "relative",
                "z-index": "3"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
                style: {
                  "width": "33.3%",
                  "display": "flex",
                  "flex-direction": "column",
                  "align-items": "center",
                  "justify-content": "center"
                },
                onClick: _cache[0] || (_cache[0] = $event => _unref(router).push({
                  name: 'recharge'
                }))
              }, [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('recharge')), 1)]), _hoisted_8, _createElementVNode("div", {
                style: {
                  "width": "33.3%",
                  "display": "flex",
                  "flex-direction": "column",
                  "align-items": "center",
                  "justify-content": "center"
                },
                onClick: _cache[1] || (_cache[1] = $event => _unref(router).push({
                  name: 'withdraw'
                }))
              }, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('withdraw')), 1)]), _hoisted_11, _createElementVNode("div", {
                style: {
                  "width": "33.3%",
                  "display": "flex",
                  "flex-direction": "column",
                  "align-items": "center",
                  "justify-content": "center"
                },
                onClick: _cache[2] || (_cache[2] = $event => _unref(router).push({
                  name: 'transfer'
                }))
              }, [_hoisted_12, _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('transfer')), 1)])])])]),
              _: 1
            }, 8, ["total"]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
              class: "balance-overview",
              style: {
                "z-index": "3",
                "position": "relative",
                "height": "100%"
              },
              onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
                name: 'balanceFunding'
              }))
            }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_unref(store).state.isLight ? (_openBlock(), _createElementBlock("img", _hoisted_17)) : (_openBlock(), _createElementBlock("img", _hoisted_18)), _createElementVNode("div", null, _toDisplayString(_unref(t)('walletTrade')), 1)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_unref(currencyTotal)) + " USD", 1), _createVNode(_unref(ArrowRightOutlined))])])]), _createElementVNode("div", {
              class: "balance-overview",
              style: {
                "position": "absolute",
                "top": "-8px",
                "left": "5%",
                "z-index": "2",
                "width": "90%",
                "opacity": "0.15"
              },
              onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
                name: 'balanceFunding'
              }))
            }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", null, _toDisplayString(_unref(t)('walletTrade')), 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(_unref(currencyTotal)) + " USD", 1)])])]), _createElementVNode("div", {
              class: "balance-overview",
              style: {
                "position": "absolute",
                "top": "0",
                "left": "7.5%",
                "z-index": "1",
                "width": "85%",
                "opacity": "0.1"
              },
              onClick: _cache[5] || (_cache[5] = $event => _unref(router).push({
                name: 'balanceFunding'
              }))
            }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", null, _toDisplayString(_unref(t)('walletTrade')), 1)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(_unref(currencyTotal)) + " USD", 1)])])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", {
              class: "balance-overview",
              style: {
                "z-index": "3",
                "position": "relative",
                "height": "100%"
              },
              onClick: _cache[6] || (_cache[6] = $event => _unref(router).push({
                name: 'balanceFutures'
              }))
            }, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_unref(store).state.isLight ? (_openBlock(), _createElementBlock("img", _hoisted_34)) : (_openBlock(), _createElementBlock("img", _hoisted_35)), _createElementVNode("div", null, _toDisplayString(_unref(t)('contract')), 1)]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, _toDisplayString(contractTotal.value) + " USD", 1), _createVNode(_unref(ArrowRightOutlined))])])]), _createElementVNode("div", {
              class: "balance-overview",
              style: {
                "position": "absolute",
                "top": "-8px",
                "left": "5%",
                "z-index": "2",
                "width": "90%",
                "opacity": "0.15"
              },
              onClick: _cache[7] || (_cache[7] = $event => _unref(router).push({
                name: 'balanceFutures'
              }))
            }, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", null, _toDisplayString(_unref(t)('contract')), 1)]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString(contractTotal.value) + " USD", 1)])])]), _createElementVNode("div", {
              class: "balance-overview",
              style: {
                "position": "absolute",
                "top": "0",
                "left": "7.5%",
                "z-index": "1",
                "width": "85%",
                "opacity": "0.1"
              },
              onClick: _cache[8] || (_cache[8] = $event => _unref(router).push({
                name: 'balanceFutures'
              }))
            }, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", null, _toDisplayString(_unref(t)('contract')), 1)]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, _toDisplayString(contractTotal.value) + " USD", 1)])])])]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", {
              class: "balance-overview",
              style: {
                "z-index": "3",
                "position": "relative",
                "height": "100%"
              },
              onClick: _cache[9] || (_cache[9] = $event => _unref(router).push({
                name: 'balancePreSale'
              }))
            }, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_unref(store).state.isLight ? (_openBlock(), _createElementBlock("img", _hoisted_51)) : (_openBlock(), _createElementBlock("img", _hoisted_52)), _createElementVNode("div", null, _toDisplayString(_unref(t)('ieoBuy')), 1)]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, _toDisplayString(_unref(ieoTotal)) + " USD", 1), _createVNode(_unref(ArrowRightOutlined))])])]), _createElementVNode("div", {
              class: "balance-overview",
              style: {
                "position": "absolute",
                "top": "-8px",
                "left": "5%",
                "z-index": "2",
                "width": "90%",
                "opacity": "0.15"
              },
              onClick: _cache[10] || (_cache[10] = $event => _unref(router).push({
                name: 'balancePreSale'
              }))
            }, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_hoisted_57, _createElementVNode("div", null, _toDisplayString(_unref(t)('ieoBuy')), 1)]), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, _toDisplayString(_unref(ieoTotal)) + " USD", 1)])])]), _createElementVNode("div", {
              class: "balance-overview",
              style: {
                "position": "absolute",
                "top": "0",
                "left": "7.5%",
                "z-index": "1",
                "width": "85%",
                "opacity": "0.1"
              },
              onClick: _cache[11] || (_cache[11] = $event => _unref(router).push({
                name: 'balancePreSale'
              }))
            }, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_hoisted_62, _createElementVNode("div", null, _toDisplayString(_unref(t)('ieoBuy')), 1)]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, _toDisplayString(_unref(ieoTotal)) + " USD", 1)])])])]), pledgeEnable.value ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_hoisted_68, _createElementVNode("div", null, _toDisplayString(_unref(t)('stakeAccount')), 1)]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, _toDisplayString(lockTotal.value) + " USD", 1)])])])) : _createCommentVNode("", true), serviceEnable.value ? (_openBlock(), _createElementBlock("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_hoisted_74, _createElementVNode("div", null, _toDisplayString(_unref(t)('serviceAccount')), 1)]), _createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, _toDisplayString(serviceTotal.value) + " USD", 1)])])])) : _createCommentVNode("", true), _createVNode(AssetsEchart, {
              array: chartsData.value,
              key: "1",
              style: {
                "margin-top": "40px"
              }
            }, null, 8, ["array"])])]),
            _: 1
          }), _createVNode(_component_van_tab, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_77, [_createVNode(WalletCard, {
              total: _unref(currencyTotal),
              "balance-show": false,
              style: {
                "position": "relative",
                "z-index": "3",
                "margin-bottom": "30px"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_78, [_createVNode(_component_van_button, {
                color: "rgb(245 245 245 / 15%)",
                class: "balance-card-btn",
                block: "",
                onClick: _cache[12] || (_cache[12] = $event => _unref(router).push({
                  name: 'recharge'
                })),
                style: _normalizeStyle(getBtnStyle('32%'))
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('recharge')), 1)]),
                _: 1
              }, 8, ["style"]), _createVNode(_component_van_button, {
                color: "rgb(245 245 245 / 15%)",
                class: "balance-card-btn",
                block: "",
                onClick: _cache[13] || (_cache[13] = $event => _unref(router).push({
                  name: 'withdraw'
                })),
                style: _normalizeStyle(getBtnStyle('32%'))
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('withdraw')), 1)]),
                _: 1
              }, 8, ["style"]), _createVNode(_component_van_button, {
                color: "rgb(245 245 245 / 15%)",
                class: "balance-card-btn",
                block: "",
                onClick: _cache[14] || (_cache[14] = $event => _unref(router).push({
                  name: 'transfer'
                })),
                style: _normalizeStyle(getBtnStyle('32%'))
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('transfer')), 1)]),
                _: 1
              }, 8, ["style"])])]),
              _: 1
            }, 8, ["total"]), _createVNode(WalletCard, {
              total: _unref(currencyTotal),
              "balance-show": false,
              style: {
                "position": "absolute",
                "top": "-5px",
                "left": "2.5%",
                "z-index": "2",
                "width": "95%",
                "opacity": "0.5"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_79, [_createVNode(_component_van_button, {
                color: "rgb(245 245 245 / 15%)",
                class: "balance-card-btn",
                block: "",
                onClick: _cache[15] || (_cache[15] = $event => _unref(router).push({
                  name: 'recharge'
                })),
                style: _normalizeStyle(getBtnStyle('32%'))
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('recharge')), 1)]),
                _: 1
              }, 8, ["style"]), _createVNode(_component_van_button, {
                color: "rgb(245 245 245 / 15%)",
                class: "balance-card-btn",
                block: "",
                onClick: _cache[16] || (_cache[16] = $event => _unref(router).push({
                  name: 'withdraw'
                })),
                style: _normalizeStyle(getBtnStyle('32%'))
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('withdraw')), 1)]),
                _: 1
              }, 8, ["style"]), _createVNode(_component_van_button, {
                color: "rgb(245 245 245 / 15%)",
                class: "balance-card-btn",
                block: "",
                onClick: _cache[17] || (_cache[17] = $event => _unref(router).push({
                  name: 'transfer'
                })),
                style: _normalizeStyle(getBtnStyle('32%'))
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('transfer')), 1)]),
                _: 1
              }, 8, ["style"])])]),
              _: 1
            }, 8, ["total"]), _createVNode(WalletCard, {
              total: _unref(currencyTotal),
              "balance-show": false,
              style: {
                "position": "absolute",
                "top": "5px",
                "left": "5%",
                "z-index": "1",
                "width": "90%",
                "opacity": "0.3"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_80, [_createVNode(_component_van_button, {
                color: "rgb(245 245 245 / 15%)",
                class: "balance-card-btn",
                block: "",
                onClick: _cache[18] || (_cache[18] = $event => _unref(router).push({
                  name: 'recharge'
                })),
                style: _normalizeStyle(getBtnStyle('32%'))
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('recharge')), 1)]),
                _: 1
              }, 8, ["style"]), _createVNode(_component_van_button, {
                color: "rgb(245 245 245 / 15%)",
                class: "balance-card-btn",
                block: "",
                onClick: _cache[19] || (_cache[19] = $event => _unref(router).push({
                  name: 'withdraw'
                })),
                style: _normalizeStyle(getBtnStyle('32%'))
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('withdraw')), 1)]),
                _: 1
              }, 8, ["style"]), _createVNode(_component_van_button, {
                color: "rgb(245 245 245 / 15%)",
                class: "balance-card-btn",
                block: "",
                onClick: _cache[20] || (_cache[20] = $event => _unref(router).push({
                  name: 'transfer'
                })),
                style: _normalizeStyle(getBtnStyle('32%'))
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('transfer')), 1)]),
                _: 1
              }, 8, ["style"])])]),
              _: 1
            }, 8, ["total"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencyList.value, item => {
              return _openBlock(), _createBlock(BalanceCurrency, {
                style: {
                  "margin-top": "10px"
                },
                key: item.id,
                active: item.active,
                freeze: item.freeze,
                btn: true,
                name: item.name,
                icon: item.icon,
                folded: item.usd,
                onClick: $event => goToHistory(0, item),
                "arrow-show": false,
                symbol: item.symbol
              }, null, 8, ["active", "freeze", "name", "icon", "folded", "onClick", "symbol"]);
            }), 128))])]),
            _: 1
          }), _createVNode(_component_van_tab, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_81, [_createVNode(WalletCard, {
              "balance-show": false,
              total: contractTotal.value,
              style: {
                "position": "relative",
                "z-index": "3",
                "margin-bottom": "30px"
              }
            }, null, 8, ["total"]), _createVNode(WalletCard, {
              "balance-show": false,
              total: contractTotal.value,
              style: {
                "position": "absolute",
                "top": "-5px",
                "left": "2.5%",
                "z-index": "2",
                "width": "95%",
                "opacity": "0.5"
              }
            }, null, 8, ["total"]), _createVNode(WalletCard, {
              "balance-show": false,
              total: contractTotal.value,
              style: {
                "position": "absolute",
                "top": "5px",
                "left": "5%",
                "z-index": "1",
                "width": "90%",
                "opacity": "0.3"
              }
            }, null, 8, ["total"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractList.value, item => {
              return _openBlock(), _createBlock(BalanceCurrency, {
                style: {
                  "margin-top": "10px"
                },
                key: item.id,
                active: item.active,
                folded: item.usd,
                freeze: item.freeze,
                name: item.name,
                icon: item.icon,
                onClick: $event => goToHistory(1, item)
              }, null, 8, ["active", "folded", "freeze", "name", "icon", "onClick"]);
            }), 128))])]),
            _: 1
          }), pledgeEnable.value ? (_openBlock(), _createBlock(_component_van_tab, {
            key: 0
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_82, [_createVNode(WalletCard, {
              "balance-show": false,
              total: lockTotal.value
            }, null, 8, ["total"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lockList.value, item => {
              return _openBlock(), _createBlock(BalanceCurrency, {
                key: item.id,
                active: item.active,
                folded: item.usd,
                freeze: item.freeze,
                name: item.name,
                icon: item.icon,
                "arrow-show": false
              }, null, 8, ["active", "folded", "freeze", "name", "icon"]);
            }), 128))])]),
            _: 1
          })) : _createCommentVNode("", true), serviceEnable.value ? (_openBlock(), _createBlock(_component_van_tab, {
            key: 1
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_83, [_createVNode(WalletCard, {
              "balance-show": false,
              total: serviceTotal.value
            }, null, 8, ["total"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serviceList.value, item => {
              return _openBlock(), _createBlock(BalanceCurrency, {
                key: item.id,
                active: item.active,
                folded: item.usd,
                freeze: item.freeze,
                name: item.name,
                icon: item.icon,
                "arrow-show": false
              }, null, 8, ["active", "folded", "freeze", "name", "icon"]);
            }), 128))])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_van_tab, null, {
            default: _withCtx(() => [_createVNode(WalletCard, {
              "balance-show": false,
              total: _unref(ieoTotal),
              style: {
                "position": "relative",
                "z-index": "3",
                "margin-bottom": "30px"
              }
            }, null, 8, ["total"]), _createVNode(WalletCard, {
              "balance-show": false,
              total: _unref(ieoTotal),
              style: {
                "position": "absolute",
                "top": "-5px",
                "left": "2.5%",
                "z-index": "2",
                "width": "95%",
                "opacity": "0.5"
              }
            }, null, 8, ["total"]), _createVNode(WalletCard, {
              "balance-show": false,
              total: _unref(ieoTotal),
              style: {
                "position": "absolute",
                "top": "5px",
                "left": "5%",
                "z-index": "1",
                "width": "90%",
                "opacity": "0.3"
              }
            }, null, 8, ["total"]), _createElementVNode("div", _hoisted_84, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ieoList.value, item => {
              return _openBlock(), _createBlock(BalanceCurrency, {
                style: {
                  "margin-top": "10px"
                },
                key: item.id,
                active: item.active,
                folded: item.usd,
                symbol: item.symbol,
                freeze: item.freeze,
                name: item.name,
                icon: item.icon,
                "arrow-show": false,
                onClick: goToIeo
              }, null, 8, ["active", "folded", "symbol", "freeze", "name", "icon"]);
            }), 128))])]),
            _: 1
          })]),
          _: 1
        }, 8, ["active"])]),
        _: 1
      }, 8, ["modelValue", "pulling-text", "loosing-text", "loading-text"])]);
    };
  }

};